// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".forget {\n  width: 360px;\n}\n.forget .el-form-item:nth-child(3) {\n  margin-bottom: 69px !important;\n}\n.forget .des {\n  font-family: Roboto;\n  font-size: 20px;\n  line-height: 28px;\n  color: #000000d9;\n  margin-bottom: 22px;\n}\n.forget .login {\n  height: 40px;\n}\n.forget .next {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}", ""]);
// Exports
module.exports = exports;
